exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.action{margin-right:5px!important}.btn-green,.btn-green:active,.btn-green:focus{background-color:#38c172!important;border-color:#38c172!important}textarea.notes{resize:none}div.vc-container{width:640px!important}", ""]);

// exports
